<template>
  <div v-if="showContent" class="layout-page-container">
    <div class="layout-page-content nav-transition">
      <div
        v-for="page in allPages"
        :key="`page-${page.key}`"
        :class="{ 'page-active': isTabActive(page) }"
      >
        <xx-container
          v-if="isTabActive(page)"
          :ref="`page-${page.key}`"
          :key="`page-${page.key}`"
          :page-key="page.key"
          :title="page.title"
          :count="page.count"
          :loading="page.loading"
          :active="isTabActive(page)"
          :back-color="page.backColor"
          :url="formatUrl(page.resUrl || page.url)"
          :target-name="page.targetName"
        >
        </xx-container>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import qs from 'query-string';
import { hGet } from "@osgfe/tools-ajax";
// eslint-disable-next-line
import {get, linkTo, isObject, cloneDeep } from '@osgfe/tools';
// eslint-disable-next-line import/no-unresolved
import { detectDeviceType } from "../../utils/tools";
import XxContainer from "./Container.vue";
import { isBlacklisted } from "./config";

const defaultConfirmOptions = {
  message: "确定要关闭此页面?",
  title: "提示",
  confirmButtonText: "确定",
  cancelButtonText: "取消",
  type: "warning",
};

export default {
  name: "XxTabView",
  components: {
    XxContainer,
  },
  inject: ["$$event", "$xxEvent", "$xxMenu", "$xxRouter"],
  data() {
    return {
      menuMap: null,
    };
  },
  computed: {
    allPages() {
      if (this.menuMap && this.menuMap.size) {
        const originURLList = Array.from(this.menuMap.keys());
        console.log(
          'get(this.$xxRouter, "pages", [])',
          get(this.$xxRouter, "pages", [])
        );
        const tempAllPages = get(this.$xxRouter, "pages", []).map((ele) => {
          const targetUrlIndex = originURLList.findIndex(
            (url) => !isBlacklisted(url) && ele.url.includes(url)
          );
          let targetTitle = "";
          if (targetUrlIndex === -1) {
            const tempArr = ele.url.split("/");
            if (tempArr.length > 3) {
              for (let i = 2; i < tempArr.length - 1; i++) {
                const targetParentUrl = `/${tempArr
                  .slice(1, i + 1)
                  .join("/")}.html`;
                const newTargetUrlIndex = originURLList.findIndex(
                  (url) => !isBlacklisted(url) && targetParentUrl.includes(url)
                );
                if (newTargetUrlIndex !== -1) {
                  targetTitle =
                    this.menuMap.get(originURLList[newTargetUrlIndex]) ||
                    ele.title;
                  break;
                }
              }
              targetTitle = targetTitle || ele.title;
            } else {
              targetTitle = ele.title;
            }
          } else {
            targetTitle =
              this.menuMap.get(originURLList[targetUrlIndex]) || ele.title;
          }
          return {
            ...ele,
            title: targetTitle,
          };
        });
        return tempAllPages;
      }
      return get(this.$xxRouter, "pages", []);
    },
    activeTabKey: {
      get() {
        console.log('get');
        try {
          document
            .getElementsByTagName("body")[0]
            .removeChild(document.querySelector('meta[name="viewport"]'));
          // eslint-disable-next-line no-empty
        } catch {}
        return get(this.$xxRouter, "loader.activePage", "");
      },
      set(val) {
        this.$$event.$emit("$tab.click", val);
        this.$$event.$emit(`$page.show.once.${val}`, val);
        return this.$xxRouter.loader.setActiveTab(val);
      },
    },
    showContent() {
      return !this.$xxMenu.dataLoading;
    },
    showTabView() {
      return !(
        this.$xxRouter.location.pathname === "/" &&
        !this.$xxRouter.location.params.url
      );
    },
    isMobile() {
      return detectDeviceType() === "Mobile";
    },
  },
  watch: {
    showTabView(val) {
      this.$emit("visible-change", val);
    },
    showContent(val) {
      if (val) {
        this.$nextTick(() =>
          this.tabScrollIntoView(this.$xxRouter.loader.activePage)
        );
      }
    },
    '$xxMenu.menuData': {
      handler: function (val) {
        if (val && val.length) {
          this.menuMap = this.consolidateToMap(cloneDeep(val));
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$$event.$on("$router.loader.page-active", this.tabScrollIntoView);

    this.$$event.$on("$page.tab.message", (key) =>
      this.$xxRouter.loader.updatePage(key, { message: true })
    );
    // API: 背景色(old) FIXME: 去掉这个旧API钩子
    this.$xxEvent.on("back-color", ({ pageKey, data = {} }) => {
      const { backColor = "#fff" } = data;
      this.$xxRouter.loader.updatePage(pageKey, { backColor });
    });
    // API: 背景色(new)
    this.$xxEvent.on("data-back-color", ({ pageKey, data = {} }) => {
      const { backColor = "#fff" } = data;
      this.$xxRouter.loader.updatePage(pageKey, { backColor });
    });
    // API: 标签标题
    this.$xxEvent.on("data-title", ({ pageKey, data = {} }) => {
      const { title } = data;
      if (title) {
        this.$xxRouter.loader.updatePage(pageKey, { title });
      }
    });
    // API: data-prompt 添加关闭确认
    this.$xxEvent.on("data-prompt", ({ pageKey, data = {} }) => {
      const { prompt = {} } = data;
      this.$xxRouter.loader.updatePage(pageKey, { prompt });
    });
    // API: 应用页面生命周期
    // 加载中
    this.$xxEvent.on("app-loading", ({ pageKey }) => {
      const pageIndex = this.$xxRouter.loader.getPageIndexByKey(pageKey);
      // 过滤页面嵌套
      if (pageIndex === -1) {
        return;
      }
      this.$$event.$emit(
        "$app.loading",
        pageKey,
        this.$xxRouter.loader.pages[pageIndex],
        this.$xxRouter,
        this
      );
    });
    // 加载完成
    this.$xxEvent.on("app-loaded", ({ pageKey }) => {
      const pageIndex = this.$xxRouter.loader.getPageIndexByKey(pageKey);
      // 过滤页面嵌套
      if (pageIndex === -1) {
        return;
      }
      this.$$event.$emit(
        "$app.loaded",
        pageKey,
        this.$xxRouter.loader.pages[pageIndex],
        this.$xxRouter,
        this
      );
    });

    // API: $tools-linkTo 打开标签
    this.$xxEvent.on("$tools-linkTo", ({ data }) => {
      const [url, params, isNewTab = false] = data;
      this.$$event.$emit("$interface.clearModal");
      this.linkToMethod(url, params, isNewTab);
    });
    // API: $tools-close 关闭标签
    this.$xxEvent.on("$tools-close", ({ pageKey }) =>
      this.onTabRemove(pageKey)
    );

    this.$xxEvent.on('$tools-urlState', ({ data }) => {
            const [params = []] = data;
            function getUrlByLockedKeys(lockedKeys) {
                const url = new URL(window.location.href);
                const newParams = new URLSearchParams();
                (lockedKeys || []).forEach((key) => {
                    const value = url.searchParams.get(key);
                    if (value !== null) {
                        newParams.set(key, value);
                    }
                });

                url.search = newParams.toString();
                return url.pathname + (url.search ? `${url.search}` : '') + (url.hash || '');
            }
            const PAGES_STORAGE_KEY = 'lsfe/skeleton/pages';
            const ACTIVE_PAGE_STORAGE_KEY = 'lsfe/skeleton/activePage';
            let pages = [];
            try {
              pages = JSON.parse(sessionStorage.getItem(PAGES_STORAGE_KEY) || '[]') || [];
            } catch (e) {
              console.log(e)
            }
            const activePageKey = sessionStorage.getItem(ACTIVE_PAGE_STORAGE_KEY) || '';
            const pageIndex = this.$xxRouter.loader.getPageIndexByKey(activePageKey);
            const newUrl = getUrlByLockedKeys(params);
            pages[pageIndex] = { ...pages[pageIndex], url: newUrl };
            sessionStorage.setItem(PAGES_STORAGE_KEY, JSON.stringify(pages));
            window.history.pushState({}, '', newUrl);
        });
  },
  methods: {
    formatUrl(url) {
      // 如果url的开头已经是/partner-alias、/finance-alias、/materials-alias或/renxiao-alias，则直接返回
      if (
        url.startsWith("/partner-alias") ||
        url.startsWith("/finance-alias") ||
        url.startsWith("/materials-alias") ||
        url.startsWith("/renxiao-alias")
      ) {
        return url;
      }
      if (url.startsWith('/micro-alias')) {
        return url.replace(/^\/micro-alias\/([^/?]+)/, `/$1-alias`);
      }
      // 删除url中的-alias，然后加上/partner-alias前缀
      const urlWithoutAlias = url.replace(/-alias/g, "");
      return `/partner-alias${urlWithoutAlias}`;
    },
    tabScrollIntoView(pageKey) {
      const tabElem = document.querySelector(`#tab-${pageKey}`);
      if (tabElem && tabElem.scrollIntoView) {
        tabElem.scrollIntoView();
      }
    },
    linkToMethod(url, params = {}, options = {}) {
      // 新 tab打开，不做特殊处理
      const {
        target = "_self", // a 标签属性
        isNewTab = false, // 是否在新 Tab打开（窗口、tab页）
        renew = false, // 是否刷新tab
        rel, // 新页面打开 referrer方式
      } = isObject(options) ? options : {};
      if (
        (typeof options === "boolean" && options === true) ||
        isNewTab ||
        target === "_blank"
      ) {
        // TODO: 数据暂存，保证新开页面无页面等数据
        const _pages = window.sessionStorage.getItem("lsfe/skeleton/pages");
        const _activePage = window.sessionStorage.getItem(
          "lsfe/skeleton/activePage"
        );
        ["lsfe/skeleton/pages", "lsfe/skeleton/activePage"].forEach((sKey) => {
          window.sessionStorage.removeItem(sKey);
        });
        if (options.rel === undefined) {
          delete options.rel;
        }
        linkTo(url, params, options);
        const timer = setTimeout(() => {
          clearTimeout(timer);
          window.sessionStorage.setItem("lsfe/skeleton/pages", _pages);
          window.sessionStorage.setItem(
            "lsfe/skeleton/activePage",
            _activePage
          );
        }, 50);
        return;
      }
      let _url = url;
      if (Object.keys(params).length > 0) {
        _url += `?${qs.stringify(params)}`;
      }
      const anchorElem = document.createElement("a");
      anchorElem.href = _url;
      _url = anchorElem.href.slice(anchorElem.origin.length);
      const menu = this.$xxMenu.getMeuByUrl(_url);
      this.$xxMenu.linkToWithOpenNewTab({
        url: _url,
        title: menu ? menu.title : "新标签页",
        target,
        rel,
        isNewTab,
        renew,
      });
    },
    isTabActive({ key }) {
      return this.$xxRouter.loader.activePage === key;
    },
    onTabRefresh(key) {
      // this.$xxRouter.loader.updatePage(key, { loading: false });
      // console.log('this.$xxRouter.loader', this.$xxRouter.loader);
      // console.log('this.$xxRouter', this.$xxRouter);
      const targetPage = this.$refs[`page-${key}`][0];
      if (targetPage) {
        targetPage.reload();
      }
    },
    onTabRemove(key) {
      const pageIndex = this.$xxRouter.loader.getPageIndexByKey(key);
      if (pageIndex === -1) {
        return;
      }
      const page = this.$xxRouter.pages[pageIndex];
      if (!page.prompt || (isObject(page.prompt) && !page.prompt.enable)) {
        this.$xxRouter.loader.closeTab(key);
        return;
      }
      const options = isObject(page.prompt)
        ? { ...defaultConfirmOptions, ...page.prompt }
        : { ...defaultConfirmOptions };
      const { message, title } = options;
      delete options.title;
      delete options.message;
      // 关闭确认
      this.$confirm(message, title, options)
        .then(() => this.$xxRouter.loader.closeTab(key))
        .catch(() => {});
    },
    consolidateToMap(dataArray) {
        const resultMap = new Map();
        function processItem(item) {
            // 添加当前项的 id 和 title
            resultMap.set(item.url, item.title);
            // 如果存在 remoteMenus，递归处理
            if (item.children && Array.isArray(item.children) && item.children.length) {
                item.children.forEach(processItem);
            }
        }
        // 处理数组中的每个元素
        dataArray.forEach((item) => {
            processItem(item);
        });
        return resultMap;
    },
  },
};
</script>

<style lang="scss" scoped>
$gray-back-color: #dee1e5;

:root,
* {
  box-sizing: border-box;
}

.layout-page-container {
    padding: 8px;
  flex: 1;
  background-color: #f0f0f0;;
}

.layout-page-content {
    height: 100%;
    overflow: hidden;

  .content-slot {
    flex: 1;
    padding: 8px 0 8px 8px;
    // height: calc(100% - 60px);
  }

  .page-active {
    height: 100%;
  }
}
.iframe-tabs-mobile {
  :deep(.el-tabs__nav-scroll) {
    overflow: auto;
  }
}
.iframe-tabs {
  :deep(.el-tabs__header) {
    position: relative;
    height: 40px;
    box-sizing: border-box;
    margin-bottom: 0;
    background: $gray-back-color;

    border-bottom: 1px solid #dee1e5;
    // border-bottom: none;
    // border-bottom-color: #aab7d0;
    .is-top {
      height: 40px;
      box-sizing: border-box;
    }

    .el-tabs__nav {
      // height:100%;
      border-radius: 0;
      border: none;
      -webkit-user-select: none; // 禁用双击文字选中高亮
    }

    .el-tabs__nav-prev,
    .el-tabs__nav-next {
      z-index: 4;
      padding: 0 4px;
      height: 40px;
      background: $gray-back-color;
      color: #585d66;
    }

    .el-tabs__nav-prev {
      box-shadow: 6px 2px 10px -4px rgba(0, 0, 0, 0.2);
    }

    .el-tabs__nav-next {
      box-shadow: -6px -2px 10px -4px rgba(0, 0, 0, 0.2);
    }

    .el-tabs__item {
      top: 4px;
      border-radius: 8px 8px 0 0;
      height: 36px;
      line-height: 36px;
      border-bottom: none !important;
      padding: 0 40px 0 24px !important;
      min-width: 120px;
      font-size: 14px;
      color: #121924;

      border-left: 0;
      position: relative;

      // 去掉蓝色边框
      &:focus.is-active.is-focus:not(:active) {
        box-shadow: none !important;
        border-radius: 0 !important;
      }

      // 消息提示
      &.is-message_diy::before {
        content: "";
        position: absolute;
        width: 10px;
        height: 10px;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
        background-repeat: no-repeat;
        background-image: url("info.png");
      }
      .el-icon-refresh:hover {
        color: #00b85c;
      }
      // 点击变为深绿色
      .el-icon-refresh:active {
        color: #06914c;
      }

      .el-icon-close {
        position: absolute;
        width: 16px !important;
        height: 16px;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
        margin: 0;
        transition: none;
        border: none;
        border-radius: 0;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          z-index: 2;
          width: 16px;
          height: 16px;
        }
      }

      &.is-closable:hover {
        &.is-active {
          .el-icon-close {
            background: none;

            &::before {
              background: url("images/gaiban/x_with_back.png") no-repeat top
                right / 16px 16px;
            }
          }
        }

        &:not(.is-active) {
          .el-icon-close {
            &::before {
              background: url("images/gaiban/x_with_back.png") no-repeat top
                right / 16px 16px;
            }
          }
        }
      }

      &.is-closable {
        &.is-active {
          .el-icon-close {
            background: none;

            &::before {
              background: url("images/gaiban/x_without_back.png") no-repeat
                center center / 7.4px 7.4px;
            }
          }
        }

        &:not(.is-active) {
          .el-icon-close {
            background: none;
          }
        }
      }

      &:not(.is-active)::after {
        content: "";
        position: absolute;
        right: 0;
        display: block;
        top: 50%;
        width: 1px;
        height: 15px;
        transform: translateY(-50%);
        border-right: 1px solid #c0cde5;
      }

      &.is-active {
        background: #fff;
        border-left: none;
        border-right: none;
        position: relative;

        &:after {
          content: "";
          background: url("images/gaiban/tab-right.png") no-repeat top right /
            22px 36px;
          position: absolute;
          top: 0;
          right: -11px;
          z-index: 2;
          width: 22px;
          height: 36px;
        }

        &:before {
          content: "";
          background: url("images/gaiban/tab-left.png") no-repeat top left /
            22px 36px;
          position: absolute;
          top: 0;
          left: -11px;
          z-index: 2;
          width: 22px;
          height: 36px;
          transform: translateY(0);
        }
      }
    }
  }

  :deep(.el-tabs__content) {
    display: none;
  }

  :deep(.el-tab-pane) {
    display: none;
  }
}
</style>
